export function formatPrice(amount, currency = "ILS") {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "";
  const safeCurrency = String(currency || "ILS").trim().toUpperCase() || "ILS";
  const floored = Math.floor(n);
  try {
    return new Intl.NumberFormat("he-IL", {
      style: "currency",
      currency: safeCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(floored);
  } catch (_) {
    return new Intl.NumberFormat("he-IL", {
      style: "currency",
      currency: "ILS",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(floored);
  }
}

